'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./success-test-drive-modal.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fixedModal = require('common/components/fixed-modal');

var _fixedModal2 = _interopRequireDefault(_fixedModal);

var _loader = require('signer/components/common/loader');

var _loader2 = _interopRequireDefault(_loader);

var _test_drive_illo = require('./test_drive_illo-01.svg');

var _test_drive_illo2 = _interopRequireDefault(_test_drive_illo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SuccessTestDriveModal = function (_Component) {
    _inherits(SuccessTestDriveModal, _Component);

    function SuccessTestDriveModal() {
        _classCallCheck(this, SuccessTestDriveModal);

        return _possibleConstructorReturn(this, (SuccessTestDriveModal.__proto__ || Object.getPrototypeOf(SuccessTestDriveModal)).apply(this, arguments));
    }

    _createClass(SuccessTestDriveModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var timeout = 4000; // 4 seconds
            var redirectUrl = '/info/chooseFreeOrEnterpriseSignupPlan';
            redirectUrl += '?enterprise=1';
            setTimeout(function () {
                window.location = redirectUrl;
            }, timeout);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(
                _fixedModal2['default'],
                { width: 400 },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-success-test-drive-modal' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-success-test-drive-modal--header' },
                        _react2['default'].createElement(
                            'h2',
                            null,
                            'Thanks! We\'ll be in touch shortly.'
                        ),
                        _react2['default'].createElement(
                            'h1',
                            null,
                            'In the meantime, feel free to take us for a test drive!'
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'loader' },
                            _react2['default'].createElement(_loader2['default'], null)
                        )
                    ),
                    _react2['default'].createElement('img', { src: _test_drive_illo2['default'] })
                )
            );
        }
    }]);

    return SuccessTestDriveModal;
}(_react.Component);

exports['default'] = SuccessTestDriveModal;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/choose-signup-plan/success-test-drive-modal.jsx
 ** module id = 1152
 ** module chunks = 0
 **/